import {
  setMeToLocalStorage,
  removeMeFromLocalStorage,
  toast
} from '../../common/js/libs/common.js';
import { showLoginReasonFromQuery } from '../../common/js/core/api/login_reason.js';
import { authApi } from './libs/apis/auth_api.js';
import { meApi } from './libs/apis/me_api.js';

// DOMが完全に読み込まれたときにイベントリスナーを初期化
document.addEventListener('DOMContentLoaded', afterLoaded);

(async function init() {
  // ログイン済みの場合は、`/`にリダイレクト
  // localStorageの値に関わらず、常にサーバ状態を確認してセッション失効時の無限ループを防ぐ
  const loginStatus = await isLoggedIn();
  if (loginStatus === true) {
    window.location.href = '/';
  } else if (loginStatus === false) {
    // 明確に未ログイン（401/403）の場合のみlocalStorageをクリア
    removeMeFromLocalStorage();
  }
  // loginStatus === null（ネットワークエラーや5xxエラー）の場合は何もしない
})();

function afterLoaded() {
  setupEventListeners();

  // 理由コード（reason）に対応する固定の文言だけを表示する。クエリの文言は表示しない
  showLoginReasonFromQuery({ toast });
}

/**
 * 入力エレメントのイベントリスナーを設定する関数
 */
function setupEventListeners() {
  setupLoginForm();
  setupPasswordToggle();
}

// ログインフォーム
function setupLoginForm() {
  const loginForm = document.getElementById('login-form');
  const loginButton = document.getElementById('login_btn');
    
  // フォームのsubmitイベントを制御
  loginForm.addEventListener('submit', (event) => {
    event.preventDefault(); // デフォルトのフォーム送信を防ぐ
    performLogin();
  });
    
  // ボタンのクリックイベントも設定（念のため）
  loginButton.addEventListener('click', (event) => {
    event.preventDefault();
    performLogin();
  });
}

// パスワード表示切り替え
function setupPasswordToggle() {
  const passwordInput = document.getElementById('password');
  const passwordToggle = document.querySelector('.password-toggle');
    
  if (passwordToggle) {
    const toggleIcon = passwordToggle.querySelector('i');
        
    passwordToggle.addEventListener('click', () => {
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        toggleIcon.classList.remove('fa-eye');
        toggleIcon.classList.add('fa-eye-slash');
      } else {
        passwordInput.type = 'password';
        toggleIcon.classList.remove('fa-eye-slash');
        toggleIcon.classList.add('fa-eye');
      }
    });
  }
}

async function performLogin() {
  const loginId = document.getElementById('login_id').value;
  const password = document.getElementById('password').value;

  try {
    await authApi.login(loginId, password);

    const result = await getMe();
    const me = {
      ...result.user,
      roles: result.roles,
      facility: result.facility,  // facility情報も保存
      feature_flags: result.feature_flags || {}
    };
    setMeToLocalStorage(me);

    // `/`にリダイレクト
    const message = 'ログインしました';
    window.location.href = `/dashboard?message=${message}`;
  } catch (error) {
    console.error('Error:', error);
    toast.error('ログインに失敗しました');
  }
}

async function getMe() {
  try {
    const response = await meApi.get();
    console.debug('Success:', response);
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

async function isLoggedIn() {
  try {
    await meApi.get();
    return true;
  } catch (error) {
    // 認証エラー（400, 401, 403）は未ログイン扱い
    // サーバー実装で400を返す場合もあるため含める
    if (error.status === 400 || error.status === 401 || error.status === 403) {
      return false;
    }
    // ネットワークエラーや5xxエラーはnullを返す（セッションの判定不能）
    console.error('セッション確認エラー:', error);
    return null;
  }
}
